<!-- src/components/DevelopmentProcess.vue -->
<template>
  <div class="development-process">
    <h2 class="section-title">停車場開發與經營流程</h2>
    <div class="process-grid">
      <div class="process-item" v-for="(item, index) in processItems" :key="index">
        <img :src="item.image" :alt="item.name" class="process-image" />
        <div class="process-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import shigonxingjian from '@/assets/cooperate/shigonxingjian.png';
import shejiguihua from '@/assets/cooperate/shejiguihua.png';
import liansuofuwu from '@/assets/cooperate/liansuofuwu.png';
import jidikaifa from '@/assets/cooperate/jidikaifa.png';
import guanlixinxiao from '@/assets/cooperate/guanlixinxiao.png';
import caiwuguihua from '@/assets/cooperate/caiwuguihua.png';

export default {
  name: 'DevelopmentProcess',
  data() {
    return {
      processItems: [
        { name: '基地開發', image: shigonxingjian },
        { name: '設計規劃', image: shejiguihua },
        { name: '施工興建', image: jidikaifa },
        { name: '財務規劃與控制', image: caiwuguihua },
        { name: '停車場經營管理與行銷', image: guanlixinxiao },
        { name: '停車場全方位連鎖服務', image: liansuofuwu },
      ],
    };
  },
};
</script>

<style scoped>
.development-process {
  /* padding: 40px 20px 64px 20px; 上:40px, 右:20px, 下:64px, 左:20px */

  width: 1416px;
  margin: 0 auto;
  padding: 0, 24px;
  /* 可选背景色 */
  /* background-color: red; */
}

/*  */

.process-grid {
  display: grid;
  grid-template-columns: repeat(3, 456px);
  /* 固定3列，每列456px */
  row-gap: 24px;
  /* 行间距24px */
  column-gap: 24px;
  /* 列间距24px */
  justify-content: center;
  /* 网格居中 */
  max-width: 1416px;
  /* 3 * 456px + 2 * 24px = 1416px */
  margin: 0 auto;
  /* 水平居中 */
}

.process-item {
  background-color: var(--green01);
  /* 使用全局 CSS 变量 */
  color: white;
  padding: 20px;
  text-align: center;


  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  /* 使用 gap 代替 margin-bottom */
  width: 456px;
  /* 固定宽度 */
  height: 312px;
  /* 固定高度 */
  box-sizing: border-box;
  border-radius: 20px;


  /* //styleName: 3xl/bold; */
  font-family: Inter;
  font-size: 28px;
  font-weight: 700;
  line-height: 38.08px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}

.process-image {
  width: 64px;
  /* 根据需要调整图片大小 */
  height: 64px;
  /* 根据需要调整图片大小 */
}


@media (max-width: 560px) {

  .development-process {
    width: 344px;

  }

  .process-grid {
    grid-template-columns: repeat(2, 166px);
    /* 2列，每列166px */
    max-width: 344px;
    /* 2 * 166px + 1 * 24px = 356px */

    row-gap: 12px;
    column-gap: 12px;
    /* background-color: red; */

  }

  .process-item {
    width: 166px;
    /* 调整宽度 */
    height: 146px;
    /* 调整高度 */


    /* //styleName: md/bold; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


    /* background-color: red; */
  }

  .process-image {
    width: 32px;
    /* 调整图片大小 */
    height: 32px;
    /* 调整图片大小 */
  }
}
</style>
